import { Controller } from "stimulus";
import { chargebeeInstance } from "../chargebee";

export default class extends Controller {
  static targets = ["form", "hostedPageId"];

  initialize() {
    this.createCheckout = this.createCheckout.bind(this);
    this.submit = this.submit.bind(this);
  }

  subscribe(e) {
    this.openDialog(e.target.dataset.plan);
    e.preventDefault();
    e.stopPropagation();
  }

  disconnect() {
  }

  openDialog(plan) {
    this.createCheckout(plan).then(this.submit).catch(error => {
      Chargebee.getInstance().logout();
    });
  }

  createCheckout(plan) {
    const instance = chargebeeInstance(this.site);

    return new Promise((resolve, reject) => {
      let createHostedPageWithPlan = () => {
        return this.createHostedPage(plan)
      }

      instance.openCheckout({
        hostedPage: createHostedPageWithPlan.bind(this),
        success: (hostedPageId) => {
          instance.closeAll();
          resolve(hostedPageId);
        }, 
        error: () => {
          reject("error");
        },
        close: () => {
          reject("close");
        }
      });
    });
  }

  createHostedPage(plan) {
    return $.ajax({
      url: this.hostedPagePath,
      type: "POST",
      data: { plan_id: plan }
    });
  }

  submit(hostedPageId) {
    this.hostedPageIdTarget.value = hostedPageId;
    this.formTarget.submit();
  }

  get site() {
    return this.data.get("site");
  }

  get hostedPagePath() {
    return this.data.get("hosted-page-path");
  }

  get createSubscriptionPath() {
    return this.data.get("create-subscription-path");
  }
}
